import { Component, type ErrorInfo, type ReactNode } from 'react'
import { reportReactError } from '../lib/errors'
import { t } from '../lib/i18n'

/**
 * Catches render errors, which `window.onerror` does not see.
 *
 * Without this a thrown render unmounts the whole tree and the user gets a blank
 * page with nothing in the log — the single hardest bug to hear about, because
 * there is nothing on screen to describe.
 */
export default class ErrorBoundary extends Component<{ children: ReactNode }, { error: Error | null }> {
  state = { error: null as Error | null }

  static getDerivedStateFromError(error: Error) {
    return { error }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    reportReactError(error, info.componentStack ?? undefined)
  }

  render() {
    if (!this.state.error) return this.props.children
    return (
      <div className="card">
        <h1>{t('error.generic')}</h1>
        <p className="muted">This has been reported. Reloading usually helps.</p>
        <button onClick={() => location.reload()}>Reload</button>
      </div>
    )
  }
}
